import {Pipe, PipeTransform} from '@angular/core';
import {RecipeDto} from '../../../Models/YuChef/Recipe/recipe.interface';

@Pipe({
  name: 'recipes',
  standalone: false
})
export class RecipesPipe implements PipeTransform {

  transform(items: RecipeDto[], filters: { id_local?: number, id_familia?: number }): RecipeDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filters.id_familia) {
      items = items.filter((item) => item['id_familia'] === filters.id_familia);
    }

    if (filters.id_local) {
      items = items.filter((item) => item['locales'].includes(Number(filters.id_local)) || item['locales'].length === 0);
    }

    return items;

  }

}
